/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './alarms-widget.scss';

/* eslint-disable import/no-unresolved, import/default */

//import siloPinGreenSvg from '../../svg/silo_pin_green.svg';

import alarmsWidgetTemplate from './alarms-widget.tpl.html';
import alarmsClearingTemplate from './alarms-clearing.tpl.html';
import alarmDetailsDialogTemplate from '../../../../../alarm/alarm-details-dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

//import tinycolor from 'tinycolor2';

export default angular.module('agrolog.client.alarmsWidget', [])
    .directive('agAlarmsWidget', AlarmsWidget)
    .name;

/*@ngInject*/
function AlarmsWidget() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            isSystem: '='
        },
        controller: AlarmsWidgetController,
        controllerAs: 'vm',
        templateUrl: alarmsWidgetTemplate
    };
}

/*@ngInject*/
function AlarmsWidgetController($rootScope, $log, $scope, $window, $timeout, $filter, $mdMedia, $mdDialog, $document, $translate,
                                $q, timeService, userService, entityService,
                                assetService, siteService, alarmService, agUserService, agUtils, agTypes, types) {
    var vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.agTypes = agTypes;

    vm.hasData = false;

    vm.alarms = [];
    vm.alarmsCount = 0;
    vm.selectedAlarms = [];

    vm.allAlarms = [];

    vm.currentAlarm = null;

    vm.allowAcknowledgment = false;
    vm.allowClear = true;
    vm.defaultSortOrder = '-'+types.alarmFields.createdTime.value;

    vm.query = {
        order: vm.defaultSortOrder,
        search: null
    };

    vm.searchAction = {
        name: 'action.search',
        show: true,
        onAction: function() {
            vm.enterFilterMode();
        },
        icon: 'search'
    };

    vm.clearMultipleAlarms = {
        name: 'ag.alarm.clear-multiple-alarms',
        show: true,
        onAction: function($event) {
            openClearMultipleAlarmsDialog($event);
        },
        icon: 'notifications_off'
    };

    vm.helpPageAction = agUtils.createHelpActionConfig("agGuiComponents", "ag.docsPageSections.alarm-widget");

    var user = userService.getCurrentUser();
    if (user.authority === 'CUSTOMER_USER') {
        var userAdditionalInfo = userService.getCurrentUserDetails().additionalInfo;
        if (userAdditionalInfo.readOnly) {
            vm.allowClear = false;
        }
    }

    vm.enterFilterMode = enterFilterMode;
    vm.exitFilterMode = exitFilterMode;
    vm.onRowClick = onRowClick;
    vm.openOriginatorDetails = openOriginatorDetails;
    vm.isAlarmSelected = isAlarmSelected;
    vm.toggleSelectAlarm = toggleSelectAlarm;
    vm.isCurrent = isCurrent;
    vm.alarmIcon = alarmIcon;
    vm.openAlarmDetails = openAlarmDetails;
    vm.createAlarmMessage = createAlarmMessage;
    vm.ackAlarms = ackAlarms;
    vm.clearAlarms = clearAlarms;
    vm.clearSelection = clearSelection;

    vm.getAlarmOriginatorName = getAlarmOriginatorName;

    vm.alarmsSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onAlarmsUpdated
        },
        timeWindowConfig: timeService.defaultTimewindow(),
        useDashboardTimewindow: false,
        alarmsPollingInterval: 5000,
        alarmSearchStatus: types.alarmSearchStatus.active
    };

    vm.alarmsSubscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
    vm.alarmsSubscriptionOptions.timeWindowConfig.realtime.timewindowMs = Date.now() - (60 * 60 * 1000);

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            initializeConfig();
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    $scope.$watch("vm.query.search", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateAlarms();
        }
    });

    $scope.$watch(function() { return $mdMedia('gt-xs'); }, function(isGtXs) {
        vm.isGtXs = isGtXs;
    });

    $scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
        vm.isGtMd = isGtMd;
    });

    $scope.$watch('vm.selectedAlarms.length', function (newLength) {
        var selectionMode = newLength ? true : false;
        if (vm.ctx) {
            if (selectionMode) {
                vm.ctx.hideTitlePanel = true;
            } else if (vm.query.search == null) {
                vm.ctx.hideTitlePanel = false;
            }
        }
    });


    vm.alarmEntities = {};
    function getAlarmOriginatorName (alarm) {
        let entity = vm.alarmEntities[alarm.originatorName];
        if (entity) {
            return entity.label || entity.name;
        } else {
            return alarm.originatorName;
        }
    }

    function setAlarmEntities (entities) {
        entities.forEach(entity => {
            vm.alarmEntities[entity.name] = entity;
        })
        updateAlarms(true);
    }

    function onAlarmsUpdated() {
        if (vm.alarmsSubscription) {
            let assetIds = [];
            let deviceIds = [];
            vm.alarmsSubscription.alarms.map(alarm => {
                if (vm.alarmEntities[alarm.originatorName]) {
                    // NOTE: do only try to fetch entities once if missing, otherwise it will fetch every 5 seconds.
                    return;
                }
                if (alarm.originator.entityType == 'ASSET') {
                    assetIds.push(alarm.originator.id);
                } else if (alarm.originator.entityType == 'DEVICE') {
                    deviceIds.push(alarm.originator.id);
                }
            })
            
            if (assetIds.length > 0) {
                entityService.getEntities('ASSET', assetIds).then(
                    function success(entities) {
                        setAlarmEntities(entities)
                    },
                    function fail() {
                    }
                )
            }
            if (deviceIds.length > 0) {
                entityService.getEntitiesPromise('DEVICE', deviceIds).then(
                    function success(entities) {
                        setAlarmEntities(entities)
                    },
                    function fail() {
                    }
                )
            }
            vm.allAlarms = vm.alarmsSubscription.alarms;
            updateAlarms(true);
            $scope.$digest();
        }
    }

    function initializeConfig() {
        vm.clearMultipleAlarms.show = vm.allowClear;
        vm.ctx.widgetActions = [ vm.clearMultipleAlarms, vm.searchAction, vm.helpPageAction ];
        vm.ctx.widgetTitle = $translate.instant('alarm.alarms') + '';

        if (vm.showData) {
            if (vm.isSystem) {
                agUserService.getAgrologCustomer().then(
                    (agCustomer) => {
                        vm.entityId = agCustomer.id;
                        loadEntity();
                    },
                    () => {
                        vm.entityId = null;
                        loadEntity();
                    }
                );
            } else {
                if (vm.ctx.stateController) {
                    vm.entityId = vm.ctx.stateController.getStateParams().entityId;
                }
                loadEntity();
                $scope.$watch(function () {
                        return vm.ctx.stateController.getStateParams().entityId;
                    },
                    function (newEntityId, prevEntityId) {
                        if (newEntityId && !angular.equals(newEntityId, prevEntityId)) {
                            vm.entityId = newEntityId;
                            loadEntity();
                        }
                    }
                );
            }
        }
    }

    function loadEntity() {
        vm.entity = null;
        reset();
        if (vm.entityId) {
            vm.loading = true;
            var entityPromise;
            if (vm.isSystem) {
                entityPromise = agUserService.getAgrologCustomer();
            } else {
                entityPromise = assetService.getAsset(vm.entityId.id);
            }
            entityPromise.then(
                function success(entity) {
                    vm.entity = entity;
                    reloadEntityAlarms();
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function reset() {
        vm.ctx.widgetTitle = $translate.instant('alarm.alarms') + '';
        if (vm.alarmsSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.alarmsSubscription.id);
        }
    }

    function reloadEntityAlarms() {
        var entityName;
        if (vm.isSystem) {
            entityName = $translate.instant('ag.alarm.system') + '';
        } else {
            entityName = vm.entity.name;
        }
        vm.ctx.widgetTitle = $translate.instant('ag.alarm.entity-alarms', {entityName: entityName}) + '';
        var alarmsSubscriptionInfo = {
            type: types.datasourceType.entity,
            entityType: vm.entityId.entityType,
            entityId: vm.entityId.id,
            entityName: vm.entity.name,
            alarmFields: [
                {name: types.alarmFields.createdTime.keyName},
                {name: types.alarmFields.originator.keyName},
                {name: types.alarmFields.type.keyName},
                {name: types.alarmFields.severity.keyName},
                {name: types.alarmFields.status.keyName}
            ]
        };
        vm.ctx.subscriptionApi.createSubscriptionFromInfo (
            types.widgetType.alarm.value, alarmsSubscriptionInfo, vm.alarmsSubscriptionOptions, false, false).then(
            function(subscription) {
                vm.alarmsSubscription = subscription;
                vm.alarmsSubscription.subscribe();
                vm.loading = false;
            }
        );
    }

    function enterFilterMode () {
        vm.query.search = '';
        vm.ctx.hideTitlePanel = true;
    }

    function exitFilterMode () {
        vm.query.search = null;
        updateAlarms();
        vm.ctx.hideTitlePanel = false;
    }

    function onRowClick($event, alarm) {
        if (vm.currentAlarm !== alarm) {
            vm.currentAlarm = alarm;
        }
    }

    function openOriginatorDetails($event, alarm) {
        if ($event) {
            $event.stopPropagation();
        }
        if (alarm.details && alarm.details.assetType) {
            var currentState = vm.ctx.stateController.getStateId();
            var assetType = alarm.details.assetType;
            alarm.originatorName = vm.getAlarmOriginatorName(alarm);
            if (assetType === agTypes.assetType.site) {
                if (currentState !== agTypes.clientState.system && currentState !== agTypes.clientState.site) {
                    vm.ctx.stateController.navigatePrevState(1);
                }
                openAssetState(agTypes.clientState.site, alarm.originator, alarm.originatorName, currentState === agTypes.clientState.system);
            } else {
                siteService.getParentSite(alarm.originator).then(
                    (site) => {
                        if (currentState !== agTypes.clientState.system) {
                            vm.ctx.stateController.navigatePrevState(1);
                        }
                        if (site.type === agTypes.assetType.site) {
                            openAssetState(agTypes.clientState.site, site.id, site.name, currentState === agTypes.clientState.system, true);
                            openChildAssetState(currentState, alarm, assetType, site.type);
                        } else { //siloGroup
                            siteService.getParentSite(site.id).then(
                                (siloGroupSite) => {
                                    openAssetState(agTypes.clientState.site, siloGroupSite.id, siloGroupSite.name, currentState === agTypes.clientState.system, true);
                                    openAssetState(agTypes.clientState.siloGroup, site.id, site.name, true, true);
                                    openChildAssetState(currentState, alarm, assetType, site.type);
                                }
                            );
                        }

                    }
                );
            }
       }
    }

    function openChildAssetState(currentState, alarm, assetType, parentAssetType) {
        var originatorName = alarm.originatorName;
        var targetState = parentAssetType === agTypes.assetType.site ?
                            agTypes.clientState.assetStates[assetType] :
                            agTypes.clientState.siloGroupAssetStates[assetType];
        if (currentState === agTypes.clientState.system) {
            $timeout(() => {
                openAssetState(targetState, alarm.originator, originatorName, true);
            }, 100);
        } else {
            openAssetState(targetState, alarm.originator, originatorName, true);
        }
    }

    function openAssetState(targetState, entityId, entityName, openElseUpdate, dontOpenRightLayout) {
        var params = getStateParams(entityId, entityName);
        if (openElseUpdate) {
            vm.ctx.stateController.openState(targetState, params, !dontOpenRightLayout);
        } else {
            vm.ctx.stateController.updateState(targetState, params, !dontOpenRightLayout);
        }
    }

    function getStateParams(entityId, entityName) {
        var params = angular.copy(vm.ctx.stateController.getStateParams());
        if (!params) {
            params = {};
        }
        params.entityId = entityId;
        params.entityName = entityName;
        return params;
    }

    function isAlarmSelected(alarm) {
        return vm.selectedAlarms.indexOf(alarm) > -1;
    }

    function toggleSelectAlarm(alarm) {
        var index = vm.selectedAlarms.indexOf(alarm);
        if (index > -1) {
            vm.selectedAlarms.splice(index, 1);
        } else {
            vm.selectedAlarms.push(alarm);
        }
    }

    function clearSelection($event) {
        if ($event) {
            $event.stopPropagation();
        }
        vm.selectedAlarms = [];
    }

    function isCurrent(alarm) {
        return (vm.currentAlarm && alarm && vm.currentAlarm.id && alarm.id) &&
            (vm.currentAlarm.id.id === alarm.id.id);
    }

    function alarmIcon(alarm) {
        if (alarm && alarm.details) {
            if (alarm.details.assetType) {
                return agUtils.getAssetIcon(alarm.details.assetType, alarm.severity, alarm.status);
            } else if (alarm.details.deviceType) {
                return agUtils.getAssetIcon(alarm.details.deviceType, alarm.severity, alarm.status);
            }
        }
        return '';
    }

    function openAlarmDetails($event, alarm) {
        if (alarm && alarm.id) {
            var onShowingCallback = {
                onShowing: function(){}
            }
            $mdDialog.show({
                controller: 'AlarmDetailsDialogController',
                controllerAs: 'vm',
                templateUrl: alarmDetailsDialogTemplate,
                locals: {
                    alarmId: alarm.id.id,
                    allowAcknowledgment: vm.allowAcknowledgment,
                    allowClear: vm.allowClear,
                    displayDetails: true,
                    showingCallback: onShowingCallback
                },
                parent: angular.element($document[0].body),
                targetEvent: $event,
                fullscreen: true,
                skipHide: true,
                onShowing: function(scope, element) {
                    onShowingCallback.onShowing(scope, element);
                }
            }).then(function (alarm) {
                if (alarm) {
                    vm.alarmsSubscription.update();
                    $rootScope.$broadcast('alarmsUpdated');
                }
            });

        }
    }

    function createAlarmMessage(alarm) {
        if (alarm.details && alarm.details.assetType === agTypes.assetType.aeration) {
            return $translate.instant('ag.alarm.aeration-state-alarm-message');
        } else if (alarm.details && alarm.details.assetType === agTypes.assetType.silo) {
            if (angular.isObject(alarm.details.message)) {
                var msg = angular.fromJson(alarm.details.message);
                var result = "";
                if (msg && msg.length) {
                    for (var i = 0; i < msg.length; i++) {
                        result += $translate.instant('ag.alarm.cable') + " " + msg[i].cableNumber + ": ";
                        for (var j = 0; j < msg[i].sensorsNumbers.length; j++) {
                            result += msg[i].sensorsNumbers[j];
                            result += (j !== msg[i].sensorsNumbers.length - 1) ? "," : ";";
                        }
                        result += (i !== msg.length - 1) ? " " : "";
                    }
                }
                return result;
            } else {
                return "";
            }
        } else {
            return "";
        }
    }

    function ackAlarms($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.selectedAlarms && vm.selectedAlarms.length > 0) {
            var title = $translate.instant('alarm.aknowledge-alarms-title', {count: vm.selectedAlarms.length}, 'messageformat');
            var content = $translate.instant('alarm.aknowledge-alarms-text', {count: vm.selectedAlarms.length}, 'messageformat');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var tasks = [];
                for (var i=0;i<vm.selectedAlarms.length;i++) {
                    var alarm = vm.selectedAlarms[i];
                    if (alarm.id) {
                        tasks.push(alarmService.ackAlarm(alarm.id.id));
                    }
                }
                if (tasks.length) {
                    $q.all(tasks).then(function () {
                        vm.selectedAlarms = [];
                        vm.alarmsSubscription.update();
                        $rootScope.$broadcast('alarmsUpdated');
                    });
                }

            });
        }
    }

    function clearAlarms($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.selectedAlarms && vm.selectedAlarms.length > 0) {
            var title = $translate.instant('alarm.clear-alarms-title', {count: vm.selectedAlarms.length}, 'messageformat');
            var content = $translate.instant('alarm.clear-alarms-text', {count: vm.selectedAlarms.length}, 'messageformat');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var tasks = [];
                for (var i=0;i<vm.selectedAlarms.length;i++) {
                    var alarm = vm.selectedAlarms[i];
                    if (alarm.id) {
                        tasks.push(alarmService.clearAlarm(alarm.id.id));
                    }
                }
                if (tasks.length) {
                    $q.all(tasks).then(function () {
                        vm.selectedAlarms = [];
                        vm.alarmsSubscription.update();
                        $rootScope.$broadcast('alarmsUpdated');
                    });
                }

            });
        }
    }


    function updateAlarms(preserveSelections) {
        if (!preserveSelections) {
            vm.selectedAlarms = [];
        }
        var result = $filter('orderBy')(vm.allAlarms, vm.query.order);
        var createdTime = 0;
        if (vm.allAlarms.length) {
            createdTime = vm.allAlarms[0].createdTime;
        }
        if (createdTime && (!vm.lastCreatedTime || createdTime > vm.lastCreatedTime)) {
            vm.lastCreatedTime = createdTime;
            $rootScope.$broadcast('alarmsUpdated');
        }
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.alarmsCount = result.length;

        if (vm.entity && vm.entity.type === agTypes.assetType.aeration) {
            //NOTE: Filter out alarms from connected systems (silo related alarms).
            result = $filter('filter')(result, {
                details: {
                    type: agTypes.assetType.aeration
                }
            });
        }

        vm.alarms = result;

        if (preserveSelections) {
            var newSelectedAlarms = [];
            if (vm.selectedAlarms && vm.selectedAlarms.length) {
                var i = vm.selectedAlarms.length;
                while (i--) {
                    var selectedAlarm = vm.selectedAlarms[i];
                    if (selectedAlarm.id) {
                        result = $filter('filter')(vm.alarms, {id: {id: selectedAlarm.id.id} });
                        if (result && result.length) {
                            newSelectedAlarms.push(result[0]);
                        }
                    }
                }
            }
            vm.selectedAlarms = newSelectedAlarms;
        }
    }

    function openClearMultipleAlarmsDialog($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.allAlarms && vm.allAlarms.length) {
            $mdDialog.show({
                controller: ClearMultipleAlarmsController,
                controllerAs: 'vm',
                templateUrl: alarmsClearingTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    allAlarms: vm.allAlarms
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event,
                onComplete: function () {
                    var w = angular.element($window);
                    w.triggerHandler('resize');
                }
            }).then(
                (selectedAlarms) => {
                    var tasks = [];
                    for (var i = 0; i < selectedAlarms.length; i++) {
                        var alarm = selectedAlarms[i];
                        if (alarm.id) {
                            tasks.push(alarmService.clearAlarm(alarm.id.id));
                        }
                    }
                    if (tasks.length) {
                        $q.all(tasks).then(function () {
                            vm.selectedAlarms = [];
                            vm.alarmsSubscription.update();
                            $rootScope.$broadcast('alarmsUpdated');
                        });
                    }
                }
            );
        }
    }
}

/*@ngInject*/
function ClearMultipleAlarmsController($mdDialog, $filter, agTypes, allAlarms) {

    var vm = this;
    vm.agTypes = agTypes;

    vm.currentAlarmTypes = [];
    vm.alarmsForClearing = allAlarms;

    for (var i = 0; i < allAlarms.length; i++) {
        if (vm.currentAlarmTypes.indexOf(allAlarms[i].type) === -1) {
            vm.currentAlarmTypes.push(allAlarms[i].type);
        }
    }

    vm.changeSelectionType = changeSelectionType;
    vm.clearAlarms = clearAlarms;
    vm.cancel = cancel;

    function changeSelectionType() {
        if (vm.alarmSelectionType === 'clear-all') {
            vm.alarmsForClearing = allAlarms;
        } else {
            vm.alarmsForClearing = $filter('filter')(allAlarms, {type: vm.alarmSelectionType});
        }
    }

    function clearAlarms() {
        $mdDialog.hide(vm.alarmsForClearing);
    }

    function cancel() {
        $mdDialog.cancel();
    }
}